export const DEFAULT_CATALOG_PRODUCTS = [
  {
    id: "prod-shake-1",
    name: "Shake Vainilla",
    tag: "15g proteína",
    pills: ["15g proteína", "Bajo en azúcar"],
    badge: "DESTACADO",
    badgeType: "featured",
    category: "Proteína & Shakes",
    price: 160,
    isFeatured: true,
    img: "/catalog/shake.jpg",
    location: "Máquinas Central Campus Universitario",
    machines: [
      "Máquinas Central Campus Universitario",
      "Máquina Torre Médica Bella Vista",
      "Máquina Gym Piantini VIP"
    ],
    spiral: "A1",
    shortDesc: "Batido proteico suave y refrescante, ideal para post-entreno o merienda.",
    description: "Batido cremoso de proteína pura de suero (whey isolate) con auténtico extracto de vainilla. Formulado para una rápida recuperación muscular, saciedad prolongada y aporte de energía limpia sin picos de glucosa.",
    nutrition: {
      calories: "180 kcal",
      protein: "15g",
      carbs: "12g",
      fats: "2.5g",
      sugars: "2g",
      fiber: "2g",
      sodium: "120mg"
    },
    ingredients: "Aislado de proteína de suero lácteo (Whey), leche deslactosada descremada, extracto natural de vainilla, stevia orgánica, complejo vitamínico B.",
    allergens: "Contiene derivados de leche. Libre de gluten y sin azúcares añadidos.",
    rating: 4.9,
    reviewsCount: 142
  },
  {
    id: "prod-almendras-1",
    name: "Almendras Tostadas",
    tag: "Sin sal",
    pills: ["Sin sal", "Alto en proteína"],
    badge: "MÁS VENDIDO",
    badgeType: "bestseller",
    category: "Frutos Secos",
    price: 110,
    isFeatured: true,
    img: "/catalog/almendras.jpg",
    location: "Máquinas General Campus Universitario",
    machines: [
      "Máquinas General Campus Universitario",
      "Máquina Plaza Corporativa BlueMall",
      "Máquina Gym Piantini VIP"
    ],
    spiral: "B2",
    shortDesc: "Almendras crujientes de tostado natural para concentración y saciedad.",
    description: "Almendras enteras seleccionadas de calibre extra, tostadas lentamente por aire seco sin aceites vegetales añadidos. Ricas en vitamina E, magnesio y antioxidantes protectores del corazón.",
    nutrition: {
      calories: "165 kcal",
      protein: "6g",
      carbs: "6g",
      fats: "14g",
      sugars: "1g",
      fiber: "3.5g",
      sodium: "5mg"
    },
    ingredients: "100% Almendras naturales horneadas al aire sin sal ni aceites añadidos.",
    allergens: "Contiene frutos de cáscara (almendras). Apto para veganos y celíacos.",
    rating: 4.8,
    reviewsCount: 98
  },
  {
    id: "prod-barra-1",
    name: "Barra de Proteína",
    tag: "20g proteína",
    pills: ["20g proteína", "Sin azúcar"],
    badge: "ALTO EN PROTEÍNA",
    badgeType: "protein",
    category: "Snacks & Barras",
    price: 150,
    isFeatured: true,
    img: "/catalog/barra-proteina.jpg",
    location: "Máquinas Central Campus Universitario",
    machines: [
      "Máquinas Central Campus Universitario",
      "Todas las máquinas VittaLink"
    ],
    spiral: "A3",
    shortDesc: "Energía y proteína en un solo bocado. Perfecta para tu rutina diaria.",
    description: "Snack proteico de alta densidad con cobertura sutil de chocolate negro 70% sin azúcar. Diseñado para brindarte 20 gramos de proteína de absorción secuencial para tu día activo.",
    nutrition: {
      calories: "210 kcal",
      protein: "20g",
      carbs: "15g",
      fats: "6g",
      sugars: "1.5g",
      fiber: "8g",
      sodium: "140mg"
    },
    ingredients: "Mezcla de proteínas (aislado de suero y proteína de soya crisp), fibra de raíz de achicoria, pasta de cacao puro, stevia.",
    allergens: "Contiene soya y lácteos. Fabricado en planta certificada libre de gluten.",
    rating: 5.0,
    reviewsCount: 210
  },
  {
    id: "prod-nueces-1",
    name: "Mix de Nueces",
    tag: "Omega 3",
    pills: ["Omega 3", "Sin conservantes"],
    badge: "100% NATURAL",
    badgeType: "natural",
    category: "Frutos Secos",
    price: 120,
    isFeatured: true,
    img: "/catalog/nueces.jpg",
    location: "Máquinas Central Campus Universitario",
    machines: [
      "Máquinas Central Campus Universitario",
      "Máquina Torre Médica Bella Vista"
    ],
    spiral: "B4",
    shortDesc: "Mezcla balanceada de nueces para más energía y bienestar.",
    description: "Combinación equilibrada de nueces de nogal, pecanas, semillas de calabaza y chía tostada al sol. Combustible cerebral cargado de fitonutrientes y grasas poliinsaturadas.",
    nutrition: {
      calories: "175 kcal",
      protein: "5.5g",
      carbs: "7g",
      fats: "15g",
      sugars: "1.2g",
      fiber: "3.2g",
      sodium: "10mg"
    },
    ingredients: "Nueces de nogal, nueces pecanas, semillas de calabaza tostadas, semillas de girasol, sal rosada ligera.",
    allergens: "Contiene frutos de cáscara. 100% Plant-Based y keto friendly.",
    rating: 4.7,
    reviewsCount: 85
  },
  {
    id: "prod-granola-1",
    name: "Barra de Granola",
    tag: "Fibra natural",
    pills: ["Fibra natural", "Baja en grasa"],
    badge: "NATURAL",
    badgeType: "natural",
    category: "Snacks & Barras",
    price: 120,
    isFeatured: true,
    img: "/catalog/granola.jpg",
    location: "Máquinas Central Campus Universitario",
    machines: [
      "Máquinas Central Campus Universitario",
      "Máquina Plaza Corporativa BlueMall"
    ],
    spiral: "C1",
    shortDesc: "Crujiente, nutritiva y deliciosa. Ideal para cualquier momento.",
    description: "Barra artesanal crujiente horneada con hojuelas de avena integral certificada, miel de abejas silvestre dominicana, coco rallado y sésamo dorado tostado.",
    nutrition: {
      calories: "155 kcal",
      protein: "4g",
      carbs: "22g",
      fats: "5g",
      sugars: "6g",
      fiber: "4.5g",
      sodium: "35mg"
    },
    ingredients: "Avena integral sin gluten, miel pura de abejas, coco deshidratado, semillas de sésamo tostado, canela.",
    allergens: "Puede contener trazas de sésamo y frutos secos. Vegetariano.",
    rating: 4.6,
    reviewsCount: 64
  },
  {
    id: "prod-matcha-1",
    name: "Té Verde Matcha",
    tag: "Antioxidantes",
    pills: ["Energía natural", "Sin azúcar"],
    badge: "ANTIOXIDANTES",
    badgeType: "antioxidant",
    category: "Bebidas Naturales",
    price: 95,
    isFeatured: true,
    img: "/catalog/matcha-te.jpg",
    location: "Máquinas Central Campus Universitario",
    machines: [
      "Máquinas Central Campus Universitario",
      "Todas las máquinas VittaLink"
    ],
    spiral: "D1",
    shortDesc: "Antioxidantes naturales que te mantienen activo durante el día.",
    description: "Matcha japonés ceremonial grado A infusionado lentamente en frío con agua purificada y un sutil toque cítrico de limón criollo. Energía mental sostenida sin nerviosismo.",
    nutrition: {
      calories: "15 kcal",
      protein: "1g",
      carbs: "2g",
      fats: "0g",
      sugars: "0g",
      fiber: "1g",
      sodium: "5mg"
    },
    ingredients: "Agua ionizada, matcha verde ceremonial japonés 100% puro, extracto cítrico natural, stevia.",
    allergens: "Sin alérgenos comunes. 100% Vegano, sin azúcar y sin gluten.",
    rating: 4.9,
    reviewsCount: 175
  },
  {
    id: "prod-matcha-barra-1",
    name: "Barra Vegetal Plant-Power",
    tag: "100% plant",
    pills: ["100% plant", "Sin lactosa"],
    badge: "VEGANO",
    badgeType: "natural",
    category: "Snacks & Barras",
    price: 140,
    isFeatured: false,
    img: "/catalog/matcha-barra.jpg",
    location: "Máquinas Central Campus Universitario",
    machines: [
      "Máquinas Central Campus Universitario",
      "Máquina Gym Piantini VIP"
    ],
    spiral: "C2",
    shortDesc: "Snack 100% vegano a base de dátiles medjool y proteína vegetal.",
    description: "Snack prensado en frío con dátiles Medjool, proteína aislada de arveja orgánica y superalimento espirulina. Dulzura natural y textura suave sin cocción agresiva.",
    nutrition: {
      calories: "170 kcal",
      protein: "11g",
      carbs: "18g",
      fats: "4.2g",
      sugars: "9g",
      fiber: "5g",
      sodium: "60mg"
    },
    ingredients: "Dátiles medjool, proteína aislada de arveja orgánica, mantequilla de almendras, espirulina en polvo.",
    allergens: "Contiene almendras. Sin lácteos, sin soya, 100% vegano.",
    rating: 4.5,
    reviewsCount: 52
  },
  {
    id: "prod-detox-1",
    name: "Jugo Verde Detox",
    tag: "Desintoxicante",
    pills: ["Prensado en frío", "Vitaminas"],
    badge: "COLD PRESSED",
    badgeType: "antioxidant",
    category: "Bebidas Naturales",
    price: 160,
    isFeatured: false,
    img: "/catalog/detox.jpg",
    location: "Máquinas Torre Médica Bella Vista",
    machines: [
      "Máquinas Torre Médica Bella Vista",
      "Máquinas Central Campus Universitario"
    ],
    spiral: "D2",
    shortDesc: "Jugo extraído en frío con manzana verde, pepino, espinaca y jengibre.",
    description: "Jugo extraído en frío por prensa hidráulica: manzana verde ácida, pepino persa, espinaca baby, apio crujiente y toque estimulante de jengibre. Cero agua ni aditivos añadidos.",
    nutrition: {
      calories: "75 kcal",
      protein: "2g",
      carbs: "16g",
      fats: "0.2g",
      sugars: "12g",
      fiber: "3.5g",
      sodium: "45mg"
    },
    ingredients: "Manzana verde fresca, pepino con cáscara, espinaca baby, tallos de apio, raíz de jengibre, limón.",
    allergens: "Contiene apio. Vegano, sin conservantes y sin pasteurización térmica.",
    rating: 4.9,
    reviewsCount: 130
  },
  {
    id: "prod-shake-plus-1",
    name: "Shake Vainilla Max Pro",
    tag: "18g proteína",
    pills: ["18g proteína", "Calcio + D3"],
    badge: "PRO CALCIO",
    badgeType: "protein",
    category: "Proteína & Shakes",
    price: 160,
    isFeatured: false,
    img: "/catalog/shake2.jpg",
    location: "Máquinas Gym Piantini VIP",
    machines: [
      "Máquinas Gym Piantini VIP",
      "Máquinas Central Campus Universitario"
    ],
    spiral: "A2",
    shortDesc: "Aporte extra de proteína y calcio con sabor cremoso a vainilla dorada.",
    description: "Fórmula fortificada con calcio bioasimilable y vitamina D3. Máximo soporte para la densidad ósea y saciedad duradera en jornadas de alta exigencia.",
    nutrition: {
      calories: "190 kcal",
      protein: "18g",
      carbs: "11g",
      fats: "3g",
      sugars: "2.5g",
      fiber: "2g",
      sodium: "135mg"
    },
    ingredients: "Aislado proteico de leche, fosfato tricálcico, colecalciferol (vitamina D3), extracto de vainilla, sucralosa.",
    allergens: "Contiene leche. Libre de gluten.",
    rating: 4.8,
    reviewsCount: 88
  }
];

export const CATALOG_CATEGORIES = [
  "Todos",
  "Destacados",
  "Proteína & Shakes",
  "Snacks & Barras",
  "Frutos Secos",
  "Bebidas Naturales"
];

export const AVAILABLE_CATALOG_IMAGES = [
  { label: "Shake Vainilla", value: "/catalog/shake.jpg" },
  { label: "Shake Vainilla Max Pro", value: "/catalog/shake2.jpg" },
  { label: "Almendras Tostadas", value: "/catalog/almendras.jpg" },
  { label: "Barra de Proteína", value: "/catalog/barra-proteina.jpg" },
  { label: "Mix de Nueces", value: "/catalog/nueces.jpg" },
  { label: "Barra de Granola", value: "/catalog/granola.jpg" },
  { label: "Té Verde Matcha", value: "/catalog/matcha-te.jpg" },
  { label: "Barra Vegetal", value: "/catalog/matcha-barra.jpg" },
  { label: "Jugo Verde Detox", value: "/catalog/detox.jpg" }
];
